import { render, staticRenderFns } from "./MuestrasTab.vue?vue&type=template&id=a20db78c"
import script from "./MuestrasTab.vue?vue&type=script&lang=js"
export * from "./MuestrasTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports